import { render, staticRenderFns } from "./HebrewHeaderComponent.vue?vue&type=template&id=26523dfb"
import script from "./HebrewHeaderComponent.vue?vue&type=script&lang=js"
export * from "./HebrewHeaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports